<template>
  <Box :class="classes" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @touch="$emit('touch', $event)">
    <slot name="default"></slot>
  </Box>
</template>

<script>

export default {
  props: {
    orientation: {
      type: String,
      default: 'horizontal'
    }
  },
  computed: {
    classes () {
      let classes = [
        'web-absolute-layout'
      ]

      return classes.join(' ')
    }
  }
}

</script>

<style scoped lang="scss">

html {
  .web-absolute-layout {
    position: relative;
  }
}

</style>